import React from 'react'
import styled from 'styled-components'

const StyledInput = styled.input`
  height: 46px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  background-color: #f3f5fb;
  border: none;
  width: 100%;
  padding-left: 12px;
`

const FormInput = ({value, name, onChange}) => {
  return <StyledInput value={value} name={name} onChange={onChange} />
}

export default FormInput
